
import { useDispatch, useSelector } from "react-redux";

import { removeImageFromPath, uploadFileToServer } from "../../../components/Forms/FormHandler.jsx";
import { toast } from "react-toastify";
import ConfigNotificationsUi from "./NotificationsUi.jsx";
import { GET_SYSTEM_CONFIG, SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { get } from "../../../../store/actions/CommonActions.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";

const ConfigNotifications = () => {
    let initialValues = {
        title: "",
        message: "",
        audience: "",
    };
    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            let method = "post";
            let endpoint = `configs/send-notifications`;
            // console.log("snvuisbevsevsdvs");
            const response = await apiCaller({ method, data: values, url: endpoint })
                .then((response) => {
                    //   dispatch(confirmedUpdatePostAction(post));
                    // history.push(backUrl);
                    // console.log('snvioesev', response);
                    return response;
                })
                .catch((error) => {
                    console.log("anvuoinsevsev", error);
                    throw error;
                });
            setSubmitting(false);
        } catch (error) { }
    };

    return (
        <ConfigNotificationsUi
            handleFormSubmit={handleFormSubmit}
            initialValues={initialValues}
        />
    );
};

export default ConfigNotifications;
